module.exports = __webpack_public_path__ + "img/icon_sec3_2@2x.12e508fb.png";